module.exports = __webpack_public_path__ + "static/2023-polb-aerial-5b2e3bb770026d9875184ea7a3a440a8.png";